/**
 * Reducer for the contact-list
 */

import { ActionTypes as types } from '../constants'
import serverProps from '../lib/server-props'

const initialState = {
  contacts: [],
  topContacts: [],
  otherContacts: [],
  permissions: serverProps.permissions,
}

/**
 * Reducer. Pure function that returns the new state for
 * the `contacts` property of the given state
 */
export default function contacts(state = initialState, action) {
  switch (action.type) {
    case types.RECEIVED_CONTACTS:
      return {
        ...state,
        topContacts: action.data.topContacts,
        otherContacts: action.data.otherContacts,
        contacts: [...action.data.topContacts, ...action.data.otherContacts],
      }

    default:
      return state
  }
}
